import { PURCHASES_ENDPOINT } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const getPurchases = userId => {
  return myFetch(`${PURCHASES_ENDPOINT}/${userId}`, "GET");
};
